/**
 * MonthProgressBanner — says the month is not over and how far the figures go (SF-5117).
 * Shown only for the month in progress; nothing for a past month or an older API.
 */
import { Alert } from 'antd';
import type { UsageProgress } from './usageClient';
import { progressBannerText } from './usageProgress';

export const MonthProgressBanner: React.FC<{ progress: UsageProgress | null | undefined }> = ({
  progress,
}) => {
  const text = progressBannerText(progress);
  if (!text) return null;
  return <Alert type="info" showIcon message={text} data-testid="month-progress-banner" />;
};
